"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _match = _interopRequireDefault(require("autosuggest-highlight/match"));

var _parse = _interopRequireDefault(require("autosuggest-highlight/parse"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getSelectedValue(nextProps) {
  return _lodash.default.chain(nextProps.suggestions).find(suggestion => suggestion.value == nextProps.selected || suggestion.label == nextProps.selected).get('label').value() || '';
}

class AutoComplete extends _react.default.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selected != prevState.selected) {
      const value = getSelectedValue(nextProps);
      return { ...prevState,
        ...{
          value,
          selected: nextProps.selected
        }
      };
    }

    return prevState;
  }

  constructor(props) {
    super(props);
    this.handleSuggestionsFetchRequested = this.handleSuggestionsFetchRequested.bind(this);
    this.handleSuggestionsClearRequested = this.handleSuggestionsClearRequested.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.descomponerString = this.descomponerString.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.getSuggestions = this.getSuggestions.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.state = {
      value: getSelectedValue(props),
      selected: props.selected,
      suggestions: []
    };
  }

  onBlur(event, {
    highlightedSuggestion
  }) {
    if (highlightedSuggestion) {
      this.setState({
        value: highlightedSuggestion.label || '',
        selected: highlightedSuggestion.value || null
      }, () => this.props.onSuggestionSelected(event, {
        suggestion: highlightedSuggestion
      }));
    }
  }

  getSuggestions(value, suggestions) {
    const inputValue = this.descomponerString(value);
    const inputLength = inputValue.length;
    let count = 0;
    let cant_results = this.props.cantResultados || 3;
    return inputLength === 0 ? [] : suggestions.filter(suggestion => {
      const keep = count < cant_results && this.descomponerString(suggestion.label).indexOf(inputValue) !== -1;

      if (keep) {
        count += 1;
      }

      return keep;
    });
  }

  descomponerString(value) {
    let quitoEspacioYMayuscula = value.trim().toLowerCase().replace(/\s/g, "");
    let quitoAcentos = quitoEspacioYMayuscula.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return quitoAcentos;
  }

  getSuggestionValue(suggestion) {
    return suggestion.label;
  }

  handleSuggestionsFetchRequested({
    value
  }) {
    this.setState({
      suggestions: this.getSuggestions(value, this.props.suggestions)
    });
  }

  handleSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    });
  }

  handleChange(event, {
    newValue
  }) {
    this.setState({
      value: newValue
    }, this.props.onChange(newValue));
  }

  renderInput(inputProps) {
    const {
      ref,
      placeholder,
      ...other
    } = inputProps;
    return (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      fullWidth: true,
      label: placeholder,
      InputProps: {
        inputRef: ref,
        classes: {
          input: _style.default.input
        },
        ...other
      }
    });
  }

  renderSuggestion(suggestion, {
    query,
    isHighlighted
  }) {
    const matches = (0, _match.default)(suggestion.label, query);
    const parts = (0, _parse.default)(suggestion.label, matches);
    return (0, _react2.jsx)(_material.MenuItem, {
      selected: isHighlighted,
      component: "div"
    }, (0, _react2.jsx)("div", null, parts.map((part, index) => part.highlight ? (0, _react2.jsx)("span", {
      key: String(index),
      style: {
        fontWeight: 300
      }
    }, part.text) : (0, _react2.jsx)("strong", {
      key: String(index),
      style: {
        fontWeight: 500
      }
    }, part.text))));
  }

  renderSuggestionsContainer(options) {
    const {
      containerProps,
      children
    } = options;
    return (0, _react2.jsx)(_material.Paper, _extends({}, containerProps, {
      square: true
    }), children);
  }

  render() {
    const {
      suggestions,
      value
    } = this.state;
    const {
      onSuggestionSelected,
      placeHolder,
      disabled
    } = this.props;
    return (0, _react2.jsx)(_reactAutosuggest.default, {
      theme: {
        container: _style.default.container,
        suggestionsContainerOpen: _style.default.suggestionsContainerOpen,
        suggestionsList: _style.default.suggestionsList,
        suggestion: _style.default.suggestion
      },
      highlightFirstSuggestion: true,
      renderInputComponent: this.renderInput,
      suggestions: suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      onSuggestionSelected: onSuggestionSelected,
      renderSuggestionsContainer: this.renderSuggestionsContainer,
      getSuggestionValue: this.getSuggestionValue,
      renderSuggestion: this.renderSuggestion,
      inputProps: {
        classes: _style.default,
        placeholder: placeHolder,
        disabled: disabled,
        value,
        onChange: this.handleChange,
        onBlur: this.onBlur,
        autoComplete: 'none'
      }
    });
  }

}

var _default = AutoComplete;
exports.default = _default;